import colors from "vuetify/lib/util/colors";

const content = {
  chart_threshold_colors: {
    Nom: colors.green.lighten3,
    Min: colors.blue.lighten3,
    Max: colors.red.lighten3,
    Alert: colors.red.accent4,
    UpperAvg: colors.red.lighten3,
    LowerAvg: colors.green.lighten3,
  },
  chart_phase_options: [
    {
      id: 0,
      label: "L1",
      color: "vtblue",
      backgroundColor: "light-blue",
    },
    {
      id: 1,
      label: "L2",
      color: "vtred",
      backgroundColor: "amber",
    },
    {
      id: 2,
      label: "L3",
      color: "indigo",
      backgroundColor: "deep-purple",
    },
  ],
  chart_values: [
    {
      id: 0,
      name: "Mean",
      label: "Mean",
      icon: "mdi-minus",
      color: "primary",
      tooltip: "Shown as a solid line",
    },
    {
      id: 1,
      name: "Min",
      label: "Min",
      icon: "mdi-view-headline",
      color: "primary",
      tooltip: "Shown as a dashed line",
    },
    {
      id: 2,
      name: "Max",
      label: "Max",
      icon: "mdi-dots-horizontal",
      color: "primary",
      tooltip: "Shown as a dotted line",
    },
  ],
  chart_palettes: {
    vt: {
      id: "vt",
      label: "VT",
      platform: "VT",
      line_colors: ["vtblue", "vtred", "indigo"],
      radio_color: "vtblue",
      point_marker_color: "orange",
    },
    h2scan: {
      id: "vt",
      label: "Custom",
      platform: "H2Scan",
      line_colors: ["vtblue", "vtred", "indigo"],
      radio_color: "vtblue",
      point_marker_color: "orange",
    },
    electrical: {
      id: "electrical",
      label: "Electrical",
      line_colors: ["brown", "darkGrey", "lightGrey"],
      radio_color: "brown",
      point_marker_color: "orange",
    },
  },
};

export { content };
